module.exports = __webpack_public_path__ + "static/img/1_pred.952635e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/photos/index/1_pred.jpg
// module id = 41
// module chunks = 0